// data-placeholder
import * as RadixSelect from '@radix-ui/react-select'
import { styled } from '../../../config'

export const TriggerPrimitive = styled(RadixSelect.Trigger, {
  color: '$gray0400',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  cursor: 'pointer',
  padding: '10px 12px',
  borderRadius: '$6',
  borderStyle: 'solid',
  borderWidth: '1px',
  '&:focus': { outline: 'none' },
  variants: {
    width: {
      full: { width: '100%' }
    },
    variant: {
      dark: {
        border: 'none',
        backgroundColor: '$whiteA050',
        color: '$whiteA800',
        '&:disabled': {
          color: '$whiteA400'
        }
      }
    }
  }
})
